import { render, staticRenderFns } from "./averageRefresh.vue?vue&type=template&id=acb54848&scoped=true&"
import script from "./averageRefresh.vue?vue&type=script&lang=js&"
export * from "./averageRefresh.vue?vue&type=script&lang=js&"
import style0 from "./averageRefresh.vue?vue&type=style&index=0&id=acb54848&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb54848",
  null
  
)

export default component.exports